const TableCont = ({children}) => {
    return (
        <div className="table-cont">
            <table id="forwardTable" data-testid="forwardTable" className="yard-table">
                {children}
            </table>
        </div>
    )
}

export default TableCont;